import React from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import { Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import NotFound from "../layout/NotFound";
import LoginPage from "../../features/auth/LoginPage";
import InicioPage from "../../features/inicio/InicioPage";
import Public from "./Public";
import Private from "./Private";
import CampaniaPage from "../../features/ofertas/campanias/CampaniaPage";
import Protected from "./Protected";
import NavBar from "../../features/nav/NavBar";
import RegisterPage from "../../features/auth/register/RegisterPage";
import RecoverPage from "../../features/auth/recover/RecoverPage";
import PrestamoPage from "../../features/consultas/prestamos/principal/PrestamoPage";
import PrestamoDetailPage from "../../features/consultas/prestamos/details/PrestamoDetailPage";
import PagarPrestamosPage from "../../features/operaciones/pagar-prestamos/principal/PagarPrestamosPage";
import CuentaPage from "../../features/consultas/cuentas/principal/CuentaPage";
import CuentaDetailPage from "../../features/consultas/cuentas/details/CuentaDetailPage";
import AperturarCuentaPage from "../../features/operaciones/aperturar-cuenta/principal/AperturarCuentaPage";
import AperturarCuentaAhorrosPage from "../../features/operaciones/aperturar-cuenta/cuenta-ahorros/AperturarCuentaAhorrosPage";
import AperturarCuentaDPFPage from "../../features/operaciones/aperturar-cuenta/cuenta-dpf/AperturarCuentaDPFPage";
// import AfiliacionPage from "../../features/afiliacion/principal/AfiliacionPage";
// import AfiliacionClaveSmsPage from "../../features/afiliacion/afiliacion-clave-sms/AfiliacionClaveSmsPage";
// import DesafiliacionClaveSmsPage from "../../features/afiliacion/desafiliacion-clave-sms/DesafiliacionClaveSmsPage";
import TransferenciasPage from "../../features/operaciones/transferencias/principal/TransferenciasPage";
import TransferenciasCuentasPropiasPage from "../../features/operaciones/transferencias/transferencias-cuentas-propias/TransferenciasCuentasPropiasPage";
import TransferenciasCuentasPrymeraPage from "../../features/operaciones/transferencias/transferencias-cuentas-prymera/TransferenciasCuentasPrymeraPage";
import TransferenciasCuentasIfisPage from "../../features/operaciones/transferencias/transferencias-cuentas-ifis/TransferenciasCuentasIfisPage";
import ValidationPage from "../../features/auth/validation/ValidationPage";
import SessionsPage from "../../features/auth/sessions/SessionsPage";

const Routes = ({ location, mediaStyles, Media, MediaContextProvider }) => {
  return (
    <>
      <Protected />
      <Container className="containerRoutes">
        <Route
          path="/(.+)"
          render={() => (
            <>
              <NavBar
                mediaStyles={mediaStyles}
                Media={Media}
                MediaContextProvider={MediaContextProvider}
              />
              <Switch>
                <Public exact path="/login" component={LoginPage} />
                <Public
                  exact
                  path="/login/validacion"
                  component={ValidationPage}
                />
                <Public exact path="/recover" component={RecoverPage} />
                <Public exact path="/register" component={RegisterPage} />
                <Private exact path="/inicio" component={InicioPage} />
                <Private exact path="/sesiones" component={SessionsPage} />
                <Private exact path="/prestamos" component={PrestamoPage} />
                <Private exact path="/cuentas" component={CuentaPage} />
                <Private
                  exact
                  path="/prestamos/:id"
                  component={PrestamoDetailPage}
                />
                <Private
                  exact
                  path="/cuentas/:id"
                  component={CuentaDetailPage}
                />
                <Private
                  exact
                  path="/pagar-prestamos"
                  component={PagarPrestamosPage}
                />
                <Private
                  exact
                  path="/aperturar-cuenta"
                  component={AperturarCuentaPage}
                />
                <Private
                  exact
                  path="/aperturar-cuenta-ahorros"
                  component={AperturarCuentaAhorrosPage}
                />
                <Private
                  exact
                  path="/aperturar-cuenta-dpf"
                  component={AperturarCuentaDPFPage}
                />
                {/* <Private exact path="/afiliacion" component={AfiliacionPage} /> */}
                <Private
                  exact
                  path="/transferencias"
                  component={TransferenciasPage}
                />
                <Private
                  exact
                  path="/transferencias-cuentas-propias"
                  component={TransferenciasCuentasPropiasPage}
                />
                <Private
                  exact
                  path="/transferencias-cuentas-prymera"
                  component={TransferenciasCuentasPrymeraPage}
                />
                <Private
                  exact
                  path="/transferencias-cuentas-ifis"
                  component={TransferenciasCuentasIfisPage}
                />
                {/* <Private
                  exact
                  path="/afiliacion-clave-sms"
                  component={AfiliacionClaveSmsPage}
                />
                <Private
                  exact
                  path="/desafiliacion-clave-sms"
                  component={DesafiliacionClaveSmsPage}
                /> */}
                <Private exact path="/campanias" component={CampaniaPage} />
                <Route component={NotFound} />
              </Switch>
            </>
          )}
        />
      </Container>
    </>
  );
};

Routes.propTypes = {
  location: PropTypes.object,
  mediaStyles: PropTypes.string.isRequired,
  Media: PropTypes.func.isRequired,
  MediaContextProvider: PropTypes.func.isRequired,
};

export default withRouter(Routes);
